(function () {
  var REVIEWS_URL = '/pages/reviews';
  var REVIEWS_LABEL = 'See all reviews';

  function scrollable(t) {
    return t.scrollWidth > t.clientWidth + 4 && getComputedStyle(t).overflowX !== 'visible';
  }
  function fit(t) {
    var cards = Array.prototype.slice.call(t.children);
    if (!cards.length) return;
    if (!scrollable(t)) {
      t.style.height = '';
      t.classList.remove('is-fit');
      return;
    }
    var left = t.scrollLeft, right = left + t.clientWidth, first = cards[0].offsetLeft, h = 0;
    cards.forEach(function (c) {
      var x = c.offsetLeft - first;
      if (x + c.offsetWidth > left + 2 && x < right - 2) h = Math.max(h, c.offsetHeight);
    });
    if (h) {
      t.classList.add('is-fit');
      t.style.height = h + 'px';
    }
  }
  function addButton(wrap) {
    if (location.pathname.replace(/\/$/, '') === REVIEWS_URL) return;
    if (!wrap || wrap.parentNode.querySelector('.ev-allrev')) return;
    var box = document.createElement('div');
    box.className = 'ev-allrev';
    var a = document.createElement('a');
    a.className = 'btn btn--ghost';
    a.href = REVIEWS_URL;
    a.textContent = REVIEWS_LABEL;
    box.appendChild(a);
    wrap.parentNode.insertBefore(box, wrap.nextSibling);
  }
  function init() {
    document.querySelectorAll('.tm__track, .revs__grid').forEach(function (t) {
      addButton(t.closest('.tm__wrap') || t);
      if (t.dataset.fit) return;
      t.dataset.fit = '1';
      var raf;
      var go = function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { fit(t); }); };
      t.addEventListener('scroll', go, { passive: true });
      window.addEventListener('resize', go);
      window.addEventListener('load', go);
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(go);
        Array.prototype.forEach.call(t.children, function (c) { ro.observe(c); });
      }
      go();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
